import Skeleton from '@cvent/carina/components/Skeleton';
import {Card} from '../card/Card';
import {useSkeletonDelay} from './useSkeletonDelay';

/**
 * Skeleton for simple message pages (CheckEmail, Success, AccountActivated, etc.)
 * Includes a 300ms delay to prevent flash on fast-loading pages
 */
export const MessageSkeleton = () => {
  const show = useSkeletonDelay();

  if (!show) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-start justify-center h-full [margin-top:var(--carina-spacing-12)]">
      <Card styleClasses="p-[32px] w-[500px] box-border max-w-full">
        {/* Title skeleton */}
        <Skeleton className="w-[250px] h-[28px] rounded mb-6" hasShimmer />

        {/* Illustration placeholder */}
        <div className="h-[120px] w-full mt-[48px] mb-[8px] flex items-center justify-center">
          <Skeleton className="w-[120px] h-[120px] rounded-lg" hasShimmer />
        </div>

        {/* Text skeleton (2-3 lines) */}
        <div className="mb-[32px] space-y-2">
          <Skeleton className="w-full h-[16px] rounded" hasShimmer />
          <Skeleton className="w-[90%] h-[16px] rounded" hasShimmer />
          <Skeleton className="w-[75%] h-[16px] rounded" hasShimmer />
        </div>

        {/* Optional button skeleton */}
        <div className="flex justify-center">
          <Skeleton className="w-[150px] h-[40px] rounded" hasShimmer />
        </div>
      </Card>
    </div>
  );
};
